<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<ViewGoalFolder
			v-if="!iEditMode && dataView"
			@close="closeModal"
			:data="dataView"
		/>
		<EditGoalFolder
			v-if="iEditMode && dataView"
			@close="closeModal"
			@submit="
				(is_completed) => {
					updateGoalLib({
						id: dataView.id,
						data: {
							is_completed,
						},
					});
					closeModal();
				}
			"
			:data="dataView"
		/>
	</DaModalFrame>
	<div v-if="folder">
		<div class="flex items-center">
			<div
				class="cursor-pointer transform"
				:class="{ 'rotate-180': folder.open }"
				@click="folder.open = !folder.open"
			>
				<svg
					width="28"
					height="28"
					viewBox="0 0 28 28"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M21 17.5L14 10.5L7 17.5"
						stroke="#94A3B8"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			</div>
			<div class="relative my-4 w-full">
				<div
					class="absolute inset-0 flex items-center"
					aria-hidden="true"
				>
					<div class="w-full border-t border-neutral-300" />
				</div>
				<div class="relative flex justify-between">
					<div class="flex items-center bg-body px-2 gap-3">
						<Checkbox
							v-if="!isInCreateGoal && isAdmin"
							:value="isSelectedAll"
							:disabled="goalsSelected?.length > 0 ? true : false"
							@click="folderClicked(folder)"
						/>
						<div v-if="!folder.is_completed">
							<svg
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M3.83345 6.39986V3.99983C3.83345 1.79063 5.69892 0 8.00016 0C10.3014 0 12.1669 1.79077 12.1669 3.99983V6.39986C13.5476 6.39986 14.6668 7.47439 14.6668 8.7999V13.6C14.6668 14.9256 13.5476 16 12.1669 16H3.83345C2.45276 16 1.3335 14.9256 1.3335 13.6V8.7999C1.3335 7.47439 2.45276 6.39986 3.83345 6.39986ZM10.5001 6.39986V3.99983C10.5001 2.67432 9.38085 1.59979 8.00016 1.59979C6.61947 1.59979 5.50021 2.67432 5.50021 3.99983V6.39986H10.5001ZM8.00016 9.6C8.46041 9.6 8.83344 9.95812 8.83344 10.4V12C8.83344 12.4419 8.46041 12.8 8.00016 12.8C7.53992 12.8 7.16689 12.4419 7.16689 12V10.4C7.16689 9.95812 7.53992 9.6 8.00016 9.6Z"
									fill="#94A3B8"
								/>
							</svg>
						</div>
						<div
							v-if="!isEdit"
							@click="folder.open = !folder.open"
							class="text-xl font-semibold text-gray-500 cursor-pointer"
						>
							{{ folderName }}
						</div>
						<div v-else class="input-group flex items-center w-fit">
							<input
								class="font-semibold"
								type="text"
								placeholder="Tên thư mục"
								v-model="folderName"
								@blur="
									updateGoal({
										id: folder.id,
										data: {
											name: folderName,
										},
									})
								"
								@keyup.enter="
									updateGoal({
										id: folder.id,
										data: {
											name: folderName,
										},
									})
								"
								:class="errorFolderName ? 'input--error' : ''"
							/>
						</div>
					</div>
					<div
						class="bg-body pl-4 flex items-center gap-4"
						v-if="!isInCreateGoal"
					>
						<span class="font-semibold text-neutral-400 text-sm">
							Mục tiêu: {{ folder?.numbers_of_goal }}
						</span>
						<div
							v-if="!isEdit"
							class="flex items-center font-semibold cursor-pointer h-5 w-5"
							@click="openModal(folder)"
						>
							<svg
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM13.3961 9.88184L9.95953 10.3125L9.83648 10.8838L10.5132 11.0068C10.9527 11.1123 11.0406 11.2705 10.9439 11.71L9.83648 16.9131C9.54644 18.2578 9.99469 18.8906 11.0494 18.8906C11.8668 18.8906 12.816 18.5127 13.2466 17.9941L13.3785 17.3701C13.0796 17.6338 12.6402 17.7393 12.3502 17.7393C11.9371 17.7393 11.7877 17.4492 11.8931 16.9395L13.3961 9.88184ZM12 8.25C12.8284 8.25 13.5 7.57843 13.5 6.75C13.5 5.92157 12.8284 5.25 12 5.25C11.1716 5.25 10.5 5.92157 10.5 6.75C10.5 7.57843 11.1716 8.25 12 8.25Z"
									fill="#94A3B8"
								/>
							</svg>
						</div>
						<div v-else>
							<Menu as="div" class="ml-3 relative">
								<div>
									<MenuButton
										class="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
									>
										<span class="sr-only"
											>Open user menu</span
										>
										<svg
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
												fill="#94A3B8"
											/>
										</svg>
									</MenuButton>
								</div>
								<transition
									enter-active-class="transition ease-out duration-200"
									enter-from-class="transform opacity-0 scale-95"
									enter-to-class="transform opacity-100 scale-100"
									leave-active-class="transition ease-in duration-75"
									leave-from-class="transform opacity-100 scale-100"
									leave-to-class="transform opacity-0 scale-95"
								>
									<MenuItems
										class="origin-top-right absolute right-0 mt-2 w-60 rounded-md py-1 bg-white focus:outline-none z-10 shadow-sm border border-yellow-100"
									>
										<MenuItem v-slot="{ active }">
											<div
												class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
												:class="active ? '' : ''"
												@click="openModal(folder)"
											>
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.9307 6.58789L6.63969 6.875L6.55766 7.25586L7.00883 7.33789C7.3018 7.4082 7.36039 7.51367 7.29594 7.80664L6.55766 11.2754C6.3643 12.1719 6.66313 12.5938 7.36625 12.5938C7.91117 12.5938 8.54398 12.3418 8.83109 11.9961L8.91898 11.5801C8.71977 11.7559 8.4268 11.8262 8.23344 11.8262C7.95805 11.8262 7.85844 11.6328 7.92875 11.293L8.9307 6.58789ZM8 5.5C8.55229 5.5 9 5.05228 9 4.5C9 3.94772 8.55229 3.5 8 3.5C7.44772 3.5 7 3.94772 7 4.5C7 5.05228 7.44772 5.5 8 5.5Z"
														fill="#94A3B8"
													/>
												</svg>

												<span>Xem thông tin</span>
											</div>
										</MenuItem>
										<MenuItem v-slot="{ active }">
											<div
												class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
												:class="active ? '' : ''"
												@click="editFolder(folder)"
											>
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M12.47 6.65078L13.71 5.41075C13.8459 5.27489 13.9138 5.20696 13.9664 5.14499C14.6006 4.39832 14.6006 3.30214 13.9664 2.55546C13.9138 2.4935 13.8459 2.42557 13.71 2.28971C13.5741 2.15385 13.5062 2.08592 13.4442 2.03329C12.6976 1.39906 11.6014 1.39906 10.8547 2.03329C10.7928 2.08591 10.7249 2.15382 10.5891 2.28961L10.589 2.28969L10.589 2.28971L9.33075 3.54792C10.0744 4.84212 11.1581 5.91739 12.47 6.65078ZM7.87608 5.00258L2.86248 10.0162C2.43742 10.4412 2.22489 10.6538 2.08516 10.9149C1.94542 11.176 1.88648 11.4707 1.76859 12.0601L1.37293 14.0384C1.30641 14.371 1.27315 14.5373 1.36776 14.6319C1.46237 14.7266 1.62867 14.6933 1.96128 14.6268L3.93956 14.2311L3.93958 14.2311L3.9396 14.2311C4.52902 14.1132 4.82374 14.0543 5.08483 13.9145C5.34592 13.7748 5.55845 13.5623 5.98349 13.1373L5.98352 13.1372L5.98352 13.1372L11.0115 8.10922C9.75086 7.31101 8.68177 6.24913 7.87608 5.00258Z"
														fill="#94A3B8"
													/>
												</svg>

												<span
													>Chỉnh sửa trạng thái</span
												>
											</div>
										</MenuItem>
										<MenuItem
											v-if="!goalChildren.length"
											v-slot="{ active }"
											@click="openCreateModal(folder)"
										>
											<div
												class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
												:class="active ? '' : ''"
											>
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
														fill="#94A3B8"
													/>
												</svg>
												<span>Thêm thư mục</span>
											</div>
										</MenuItem>
										<MenuItem
											v-slot="{ active }"
											@click="openCreateFirstMode"
											v-if="
												!goalChildren.length &&
												!folderChildren.length
											"
										>
											<div
												class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
												:class="active ? '' : ''"
											>
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
														fill="#94A3B8"
													/>
												</svg>
												<span>Thêm mục tiêu</span>
											</div>
										</MenuItem>
										<MenuItem v-slot="{ active }">
											<div
												class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
												:class="active ? '' : ''"
												@click="
													deleteGoal({
														itemId: folder.id,
														isGoal: false,
													})
												"
											>
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
														fill="#94A3B8"
													/>
												</svg>
												<span>Xoá thư mục</span>
											</div>
										</MenuItem>
									</MenuItems>
								</transition>
							</Menu>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="errorFolderName && isEdit">
			<div class="w-full mb-2" style="margin-left: 28px">
				<div class="error text-sienna-600 text-sm w-full">
					{{ errorFolderName }}
				</div>
			</div>
		</div>
		<div v-if="folder.open">
			<div
				v-if="
					goalChildren.length ||
					folderChildren.length ||
					(isEdit && isCreatFirst)
				"
			>
				<GoalItemsTable
					v-if="goalChildren.length || (isEdit && isCreatFirst)"
					:goals="goalChildren"
					:is-edit="isEdit"
					:skills="skills"
					:is-in-create-goal="isInCreateGoal"
					:group-create="groupCreate"
					:form-create="formCreate"
					:parent-id="folder.id"
					:force-checked="onlyFolder && isSelectedAll"
					:show-create-row="
						isEdit &&
						(goalChildren.length > 0 || isCreatFirst)
					"
					:assistance_levels="assistance_levels"
					@create-goal="createGoal"
					@delete-goal="deleteGoal"
					@updated="$emit('updated')"
					@action-clicked="(data) => $emit('action-clicked', data)"
					@fetch-new="(data) => $emit('fetchNew', data)"
				>
					<template v-if="isInCreateGoal || $slots.actions" #actions>
						<slot name="actions">
							<div></div>
						</slot>
					</template>
				</GoalItemsTable>
				<div v-if="folderChildren.length" class="pl-10">
					<div v-for="child in folderChildren" :key="child.id">
						<GoalFolderItem
							:is-edit="isEdit"
							:data="child"
							:skills="skills"
							:assistance_levels="assistance_levels"
							@updated="$emit('updated')"
							@create-goal="createGoal"
							@update-goal="updateGoal"
							@delete-goal="deleteGoal"
							@open-create-modal="openCreateModal"
							@action-clicked="
								(data) => $emit('action-clicked', data)
							"
							:isInCreateGoal="isInCreateGoal"
							:groupCreate="groupCreate"
							:is-search="isSearch"
							:only-folder="onlyFolder"
							@fetch-new="(data) => $emit('fetchNew', data)"
							><template v-if="isInCreateGoal" v-slot:actions
								><div></div></template
						></GoalFolderItem>
					</div>
				</div>
			</div>
			<div v-else class="text-gray-500">
				Thư mục không có mục tiêu hay thư mục nào
			</div>
		</div>
	</div>
</template>

<script>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import ViewGoalFolder from '@/views/goalFolders/features/ViewGoalFolder';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame';
import { $api } from '@/services';
import EditGoalFolder from '@/views/goalFolders/features/EditGoalFolder';
import Checkbox from '@/components/elements/checkbox/Checkbox';
import GoalItemsTable from './GoalItemsTable.vue';

export default {
	name: 'GoalFolderItem',

	components: {
		EditGoalFolder,
		DaModalFrame,
		ViewGoalFolder,
		Menu,
		MenuItem,
		MenuItems,
		MenuButton,
		Checkbox,
		GoalItemsTable,
	},

	props: {
		data: {
			type: Object,
			required: true,
		},
		isEdit: {
			type: Boolean,
			required: true,
		},
		skills: {
			type: Array,
			required: true,
		},
		isInCreateGoal: {
			type: Boolean,
			default: false,
		},
		isSearch: {
			type: Boolean,
			default: false,
		},
		isCheckedAll: {
			type: Boolean,
			default: false,
		},
		onlyFolder: {
			type: Boolean,
			default: false,
		},
		assistance_levels: {
			type: Array,
			default: () => [],
		},
		groupCreate: {
			type: Boolean,
			default: false,
		},
		formCreate: {
			type: Boolean,
			default: false,
		},
	},

	watch: {
		folder: {
			immediate: true,
			handler(value) {
				this.errorFolderName = '';
				this.folderName = value?.name;
				this.allChild = [];
				this.allChildIsFolder = [];
				if (value) {
					this.onlyFolder
						? this.getAllChildFolderIsFolder(value)
						: this.getAllChildFolder(value);
				}
			},
		},

		isEdit: {
			handler(value) {
				if (!value) {
					this.closeCreateFirstMode();
				}
			},
		},
	},

	computed: {
		id() {
			return this.$route?.params?.id || '';
		},

		isAdmin() {
			return this.$store.getters.isAdmin;
		},

		org() {
			return this.$store.state.profile.current_org;
		},

		isSelectedAll() {
			if (this.onlyFolder) {
				return [
					...this.foldersSelected,
					...this.childFoldersSelected,
				].includes(this.folder?.id);
			}

			return (
				this.allChild.length &&
				this.allChild.every((i) =>
					this.goalsSelected.find((c) => c === i.id)
				)
			);
		},

		goalsSelected() {
			const s = this.$store.getters.goalsSelected;
			return (s || []).map((i) => i.id);
		},

		foldersSelected() {
			const s = this.$store.getters.foldersSelected;
			return (s || []).map((i) => i.id);
		},

		childFoldersSelected() {
			const s = this.$store.getters.childFoldersSelected;
			return (s || []).map((i) => i.id);
		},

		isHide() {
			return this.$store.getters.goalHides.includes(this.folder.id);
		},
		folder() {
			return this.data;
		},
		goalChildren() {
			return (this.folder?.children || []).filter((c) => c.is_goal);
		},
		folderChildren() {
			return (this.folder?.children || []).filter((c) => !c.is_goal);
		},
	},

	data() {
		return {
			folderName: '',
			modalIsOpen: false,
			dataView: null,
			isCreatFirst: false,
			errorFolderName: '',
			iEditMode: false,
			allChildSelected: [],
			allChild: [],
			allChildIsFolder: [],
		};
	},

	created() {
		this.$store.dispatch('clearHide');
		this.$store.dispatch('clearTaught');
	},

	methods: {
		getAllChild(parent) {
			const listChild = parent.children || [];
			for (let child of listChild) {
				if (child.is_goal) {
					this.allChildSelected = [
						...this.allChildSelected,
						child,
					];
				} else {
					this.getAllChild(child);
				}
			}
		},
		getAllChildFolder(parent) {
			const listChild = parent.children || [];
			for (let child of listChild) {
				if (child.is_goal) {
					this.allChild = [...this.allChild, child];
				} else {
					this.getAllChildFolder(child);
				}
			}
		},
		getAllChildFolderIsFolder(parent) {
			const listChild = parent.children || [];
			for (let child of listChild) {
				if (!child.is_goal) {
					this.allChildIsFolder = [
						...this.allChildIsFolder,
						child,
					];
					this.getAllChildFolderIsFolder(child);
				}
			}
		},

		toggleHide() {
			this.$store.dispatch('hide', {
				goal: { id: this.folder.id },
			});
		},

		openCreateFirstMode() {
			this.isCreatFirst = true;
			this.folder.open = true;
		},

		closeCreateFirstMode() {
			this.isCreatFirst = false;
		},

		openCreateModal(data) {
			this.$emit('open-create-modal', data);
		},

		createGoal(data) {
			this.$emit('create-goal', data);
		},

		updateGoal(data) {
			this.updateGoalLib(data);
		},

		deleteGoal(data) {
			this.$emit('delete-goal', {
				...data,
				root: false,
			});
		},

		closeModal() {
			this.dataView = null;
			this.modalIsOpen = false;
			this.iEditMode = false;
		},

		openModal(data) {
			this.dataView = data;
			this.modalIsOpen = true;
			this.iEditMode = false;
		},

		editFolder(data) {
			this.dataView = data;
			this.modalIsOpen = true;
			this.iEditMode = true;
		},

		selectedFolder(folder) {
			this.$store.dispatch('folderSelected', { folder });
		},

		async checkChangedChild(goals, isAll) {
			this.allChildSelected = [];
			await this.getAllChild(goals);
			this.checkChanged(this.allChildSelected, isAll);
		},

		checkChanged(goals, isAll) {
			this.$store.dispatch('selected', { goals, isAll });
			for (let goal of goals) {
				if (goal.sub_item_count > 0) {
					for (let s of goal.sub_items) {
						this.checkChanged([s]);
					}
				}
			}
		},

		async updateGoalLib({ id, data }) {
			this.errorFolderName = '';
			try {
				await $api.goal.updateGoalByParent(this.id, id, data);
				this.$store.dispatch('setAlertMessage', {
					message: 'Cập nhật mục tiêu thành công',
				});
				this.$emit('updated');
			} catch (e) {
				if (
					e?.response?.data?.errors_by_field &&
					e?.response?.data?.errors_by_field['library_items']
				) {
					this.errorFolderName =
						'Tên thư mục mới không được trùng với tên thư mục đã có trước đó.';
				} else {
					await this.$store.dispatch('setAlertMessage', {
						message:
							e?.response?.data?.errors?.join('<br/>') ||
							'Đã có lỗi xảy ra. Vui lòng thử lại',
						type: 'danger',
					});
				}
			}
		},

		folderClicked(folder) {
			if (!this.onlyFolder) {
				this.checkChangedChild(folder, !this.isSelectedAll);
			} else if (!this.goalsSelected?.length) {
				if (!this.childFoldersSelected.includes(folder.id)) {
					if (this.foldersSelected.includes(folder.id)) {
						this.$store.dispatch('clearChildrenSelected');
					} else {
						this.$store.dispatch('childFolderSelected', {
							folders: this.allChildIsFolder,
						});
					}
					this.selectedFolder(folder);
				}
			}
		},
	},
};
</script>
